import { ErrorHandler, inject, Provider } from '@angular/core';
import { environment } from '@env/environment';

import { Logger } from '@app/core/logging/logger';
import { AppInsightsLogger } from '@app/core/logging/app-insights-logger.service';
import { ConsoleLogger } from '@app/core/logging/console-logger.service';
import { GlobalErrorHandler } from '@app/core/logging/global-exception.handler';

export function loggerFactory(): Logger {
    return environment.production ? inject(AppInsightsLogger) : inject(ConsoleLogger);
}

export const loggingProviders: Provider[] = [
    AppInsightsLogger,
    ConsoleLogger,
    { provide: Logger, useFactory: loggerFactory },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
];
